import {
  createTRPCClient,
  httpBatchLink,
  httpLink,
  splitLink,
  retryLink,
} from '@trpc/client'

import type { ProxyRouter } from './proxy.server'

const MAX_RETRIES = 3
const BASE_DELAY_MS = 500
const MAX_DELAY_MS = 5_000
const JITTER_FACTOR = 0.3

const links = [
  retryLink<ProxyRouter>({
    retry(opts) {
      if (
        opts.error.data?.code === 'INTERNAL_SERVER_ERROR' ||
        opts.error.data?.code === 'TIMEOUT' ||
        !opts.error.data
      ) {
        return opts.attempts <= MAX_RETRIES
      }
      return false
    },
    retryDelayMs: (attempt) => {
      let delay = Math.pow(2, attempt) * BASE_DELAY_MS
      const jitter = delay * JITTER_FACTOR * (Math.random() - 0.5) * 2
      delay = delay + jitter
      return Math.min(delay, MAX_DELAY_MS)
    },
  }),
  splitLink<ProxyRouter>({
    condition(op) {
      return op.context.skipBatch as boolean
    },
    true: httpLink({ url: '/trpc' }),
    false: httpBatchLink({ url: '/trpc' }),
  }),
]

export const proxyTrpc = createTRPCClient<ProxyRouter>({
  links,
})
